var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaterPressure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: 20,
      height: 20,
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480 64C321.28 64 192 193.28 192 352c0 147.776 112.512 268.48 256 284.8V704H64v64h411.008a35.2 35.2 0 0 0 10.24 0H896v-64H512V636.8c143.488-16.32 256-137.024 256-284.8C768 193.28 638.72 64 480 64z m0 64C604.032 128 704 228.032 704 352a223.168 223.168 0 0 1-220.8 223.488h-3.712c-0.768 0-1.728 0.256-2.496 0.256A223.424 223.424 0 0 1 256 352C256 227.968 356.032 128 480 128z m63.488 127.744a31.488 31.488 0 0 0-22.016 9.728l-64 64a31.872 31.872 0 1 0 45.056 45.056l64-64a31.872 31.872 0 0 0-23.04-54.784zM64 832v64h832v-64z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterPressure);
export default __webpack_public_path__ + "static/media/water-pressure.f51e450652ce2f95681eca26309b9f37.svg";
export { ForwardRef as ReactComponent };